var React = require('react');

function AlertBannerLeftArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"arrow","d":"M6.5,0,0,7.3,1.517,9,6.5,3.405,11.483,9,13,7.3Z","transform":"translate(0.752 13.67) rotate(-90)","fill":"#6e6e6e","stroke":"#fff","strokeWidth":"1"}));
}

AlertBannerLeftArrow.defaultProps = {"width":"10.503","height":"14.339","viewBox":"0 0 10.503 14.339"};

module.exports = AlertBannerLeftArrow;

AlertBannerLeftArrow.default = AlertBannerLeftArrow;
